export default __webpack_public_path__ + "static/media/satellite-map-image.24953a99.PNG";